import { QuestionTemplateDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { surveyApi } from "../services/SurveyApi";

export const useQuestionTemplates = () => {
  const [questionTemplates, setQuestionTemplates] = useState<QuestionTemplateDTO[]>([]);
  const [isQuestionTemplatesLoading, setIsQuestionTemplatesLoading] = useState<boolean>();

  const loadQuestionTemplates = useCallback(async () => {
    setIsQuestionTemplatesLoading(true);
    const templates = await surveyApi.questionTemplatesGlobal();
    setQuestionTemplates(templates);
    setIsQuestionTemplatesLoading(false);
  }, []);

  return { isQuestionTemplatesLoading, questionTemplates, loadQuestionTemplates };
};
